import { useRef } from 'react';

import { useTimelineAutoScroll } from './useTimelineAutoScroll';
import { useTimelineHeaderScrollbarGap } from './useTimelineHeaderScrollbarGap';
import { useTimelineHeaderScrollSync } from './useTimelineHeaderScrollSync';

/* La frise "Timeline" n'utilise plus position:sticky pour figer la colonne de noms / l'en-tête :
   ça ne tenait pas de façon fiable une fois qu'on scrollait loin (vérifié en Chrome/Mac). À la
   place : deux volets séparés qui ne font jamais partie de la zone qui défile horizontalement.
   - tlScrollRef : SEUL conteneur de scroll vertical, partagé par la colonne de noms et le corps
     (pas de synchro JS nécessaire pour cet axe : ils défilent ensemble nativement).
   - tlBodyScrollRef : scroll horizontal du corps (jours + barres) — c'est la vraie scrollbar,
     utilisée aussi par l'auto-scroll pendant un drag/resize.
   - tlHeaderScrollRef : l'en-tête (mois/semaine/jours) suit le scroll horizontal du corps en JS
     (lui-même n'est jamais scrollé directement par l'utilisateur). */
export function useTimelineScroll({ appState, timelineDrag, timelineResize }) {
  const timelineScrollRef = useRef(null);
  const timelineBodyScrollRef = useRef(null);
  const timelineHeaderScrollRef = useRef(null);
  const timelineHeaderGridRef = useRef(null);
  const timelineLastMouseX = useRef(null); // dernier clientX connu du curseur, lu par l'auto-scroll (même si la souris ne bouge plus)
  useTimelineAutoScroll({
    timelineBodyScrollRef,
    timelineDrag,
    timelineLastMouseX,
    timelineResize,
  });
  useTimelineHeaderScrollbarGap({ timelineHeaderScrollRef, timelineScrollRef });
  useTimelineHeaderScrollSync({ appState, timelineBodyScrollRef, timelineHeaderGridRef });
  return {
    timelineBodyScrollRef,
    timelineHeaderGridRef,
    timelineHeaderScrollRef,
    timelineLastMouseX,
    timelineScrollRef,
  };
}
